<!-- 裁剪图片 -->
<template>
    <div id = "cucropper">
        <Modal v-model = "cropperShowFlag" width = "700" :transition-names = 'transitionNames'  class-name="vertical-center-modal" :closable = 'closable' title="图片剪切" :mask-closable = "mask_closable">
            <div class="cropper">
                <div class="body1">
                    <div class="body1_content">
                        <vueCropper ref="cropper2"  :img="example2.img " :outputSize="example2.size" :outputType="example2.outputType"
                            :info="example2.info" :canScale="example2.canScale" :autoCrop="example2.autoCrop"
                            :autoCropWidth="example2.autoCropWidth" :autoCropHeight="example2.autoCropHeight" :fixed="example2.fixed"
                            :fixedNumber="example2.fixedNumber" :enlarge="4"></vueCropper>
                    </div>
                </div>
            </div>
            <div slot="footer">
                <div class="cropper_footer">
                    <a class = "btn btns" href = "javascript:void(0);" @click = '_closeCutImg'>取消</a>
                    <label class="btn" for="upload2">选择图片</label>
                    <input type="file" id="upload2" style="position:absolute; clip:rect(0 0 0 0);"
                    accept="image/png, image/jpeg, image/gif, image/jpg" @change="uploadImg($event,2)">
                    <button @click="cutImg()" class="btn">确认裁剪并上传</button>
                </div>
            </div>
        </Modal>
    </div>
</template>
 
<script>

    // 导入图片剪切
    import { VueCropper } from 'vue-cropper';
    import { Message } from 'view-design';

    // 导出模块
    export default {
        
        // 名称
        name: 'cu-cropper',
        
        // 图片剪切组件
        components: {
            VueCropper,
        },

        // 接口
        props: {

            // 显示flag
            cropperShowFlag: {
                type: Boolean,
                default: false
            }
        },

        // 数据
        data() {
            return {
                // 点击遮罩层不允许关闭
                mask_closable: false,
                // 关闭
                closable: false,
                model: false,
                modelSrc: '',
                crap: false,
                previews: {},
                form: {
                head: ''
                },
                example2: {
                //img的路径自行修改
                img: '',
                info: true,
                size: 1,
                outputType: 'png',
                canScale: true,
                autoCrop: true,
                // 只有自动截图开启 宽度高度才生效
                autoCropWidth: 300,
                autoCropHeight: 250,
                fixed: true,
                // 真实的输出宽高
                infoTrue: true,
                fixedNumber: [4, 3]
                },
                downImg: '#',
                transitionNames: []
            }
        },

        // 监听方法
        watch: {

            /**
             * @author lihh
             * @description 监听弹框显隐变化
             */
            cropperShowFlag: function(val) {

                if (val) this.example2.img = '';
            }
        },

        // 方法
        methods: {

            /**
             * @author lihh
             * @description 点击
             */
            _closeCutImg() {

                this.$emit('_closeCutImg');
            },
            
            /**
             * @author lihh
             * @description 点击按钮 进行图片剪切
             */
            cutImg() {

                // 点击图片剪切
                this.$refs.cropper2.getCropData((data) => {

                    // 传递给父类
                    this.$emit('_cutImg', data);
                })
            },
    
            /**
             * @author lihh
             * @description 进行图片上传
             */
            uploadImg(e, num) {

                //上传图片
                this.example2.img = '';
                // 获取文件流
                let file = e.target.files[0];
                // 判断文件格式 是否正确
                if (!/\.(jpg|jpeg|png|JPG|PNG)$/.test(e.target.value)) {

                    Message.error('图片类型必须是jpeg,jpg,png中的一种');
                    return false
                }
                let reader = new FileReader();
                // 文件流回调
                reader.onload = (e) => {
                    let data = e.target.result
                    if (typeof e.target.result === 'object') {
                        // 把Array Buffer转化为blob 如果是base64不需要
                        data = window.URL.createObjectURL(new Blob([e.target.result]))
                    } else {
                        data = e.target.result
                    }
                    if (num === 1) {
                        this.option.img = data
                    } else if (num === 2) {
                        this.example2.img = data
                    }
                }
                reader.readAsArrayBuffer(file)
            },
            /**
             * @author lihh
             * @description base64转blob
             */
            toBlob(ndata) {

                // ndata为base64格式地址
                let arr = ndata.split(','),
                mime = arr[0].match(/:(.*?);/)[1],
                bstr = atob(arr[1]),
                n = bstr.length,
                u8arr = new Uint8Array(n);
                while (n--) {
                    u8arr[n] = bstr.charCodeAt(n);
                }
                return new Blob([u8arr], {
                    type: mime
                })
            }
        },
    
    }
</script>
 
<style lang = "less" scoped>
    /* #cucropper /deep/ .vertical-center-modal {
        display: flex;
        align-items: center;
        justify-content: center;
        
        .ivu-modal {
            top: 0;
        }
    } */
    #cucropper /deep/ .ivu-modal {
        position: fixed;
        top: 0px;
        left: 0px;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
    .cropper {
        .body1_content {
            width: 600px;
            margin: 0px auto;
            height: 300px;
        }
    }
    .cropper_footer {
        .btn {
            display: inline-block;
            line-height: 1;
            white-space: nowrap;
            cursor: pointer;
            background: #fff;
            border: 1px solid #c0ccda;
            color: #1f2d3d;
            text-align: center;
            box-sizing: border-box;
            outline: none;
            margin: 20px 10px 0px 0px;
            padding: 9px 15px;
            font-size: 14px;
            border-radius: 4px;
            color: #fff;
            background-color: #50bfff;
            border-color: #50bfff;
            transition: all .2s ease;
            text-decoration: none;
            user-select: none;
        }
        .btns {
            background: #ffffff;
            border: none;
            color: #2d8cf0;
        }
    }
</style>


// WEBPACK FOOTER //
// src/packages/Cropper/CuCropper/Cu-Cropper.vue